import React from "react";
import { useParams } from "react-router-dom";

export default function ViewEmployee() {
  const { id } = useParams();

  const data = {
    1: { name: "John Doe", email: "john@example.com", department: "Sales", designation: "Executive" },
    2: { name: "Jane Smith", email: "jane@example.com", department: "HR", designation: "Manager" },
    3: { name: "Robert Brown", email: "robert@example.com", department: "IT", designation: "Engineer" },
  };

  const emp = data[id];

  if (!emp) return <p>No employee found</p>;

  return (
    <div className="max-w-xl mx-auto bg-white p-6 rounded-xl shadow-lg">
      <h1 className="text-3xl font-bold text-blue-700 mb-4">Employee Details</h1>

      <div className="space-y-3">
        <p><strong>Name:</strong> {emp.name}</p>
        <p><strong>Email:</strong> {emp.email}</p>
        <p><strong>Department:</strong> {emp.department}</p>
        <p><strong>Designation:</strong> {emp.designation}</p>
      </div>
    </div>
  );
}
